import { useState } from "react";
import { useLocation } from "react-router-dom";

export const sidebarData = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: '📊'
    },
    {
        title: 'Create New',
        path: '/create-new',
        icon: '➕'
    },
    {
        title: 'All List',
        path: '/all-list',
        icon: '👥'
    }
];

export const handleLogout = (navigate, toastService) => {
    try {
        // Clear any stored auth data
        localStorage.clear();
        sessionStorage.clear();

        // Show success toast
        toastService.success("Log out successfully!");

        // Redirect to login page
        setTimeout(() => {
            navigate("/");
        }, 500);
    } catch (error) {
        toastService.error("Logout failed. Please try again.");
    }
};

export const useSidebarData = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [openDropdown, setOpenDropdown] = useState(null);
    const location = useLocation();

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const hasActiveSubmenu = (subMenu) => {
        return subMenu?.some(item => location.pathname === item.path);
    };
    return {
        toggleDropdown,
        isOpen,
        openDropdown,
        isActive,
        hasActiveSubmenu,
        setIsOpen
    };
};